<template>
    <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">课程讲师列表</div>
        </div>
        <div class="rightBox">
            <div class="lecturerBox">
                <div class="topHeader clear">
                    <div class="newlecturerBtn" @click="bindAdd('新增讲师')">新增讲师+</div>
                    <div class="searchBox flex">
                        <el-input v-model="params.name" placeholder="请输入讲师姓名" />
                        <div class="searchBtn" @click="getData( 1 )">查询</div>
                    </div>
                    <div class="reset" @click="bindReset">↻重置</div>
                </div>
                <!---->
                <div class="lecturerBox">
                    <div class="itemlecturer list-complete-item clear" v-for="(item,idx) in data.list" >
                        <div class="imgBox">
                            <img :src="item.avatar" alt="">
                        </div>
                        <div class="contentBox">
                            <div class="name clear"><span class="spanName">{{ item.name }}</span>
                                <!---->
                            </div>
                            <div class="title">讲师介绍:</div>
                            <div class="contents">{{ item.content }}</div>
                            <div class="operation">
                                <div class="editor" @click="bindEdit(idx,'修改讲师')">编辑</div>
                                <div class="del" @click="bindDel(item.id)">删除</div>
                            </div>
                            <!---->
                        </div>
                    </div>
                </div>
                <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="params.pageSize" @current-change="bindPage" />
                <!-- 新增讲师 -->
                <div class="mask"  v-show="addJsStatus">
                    <div class="createSpeaker">
                        <div class="topHeader clear">
                            <div class="leftTitle">{{ fcTit }}</div>
                            <div class="close" @click="addJsStatus = false"><span class="iconfont" @click="openAddFc"></span></div>
                        </div>
                        <div class="createBox">
                            <el-form :model="query" :rules="queryRules" ref="queryFormRef">
                                <el-form-item prop="avatar" class="logoPic">
                                    <ImageUpload @handleUploadSuccess="uploadAvatarSuccess($event)" :url="query.avatar"></ImageUpload>
                                </el-form-item>
                                <el-form-item label="讲师姓名：">
                                    <el-input v-model="query.name" placeholder="请输入讲师姓名" />
                                </el-form-item>
                                <el-form-item label="讲师介绍："  prop="content">
                                    <el-input :rows="6" type="textarea" v-model="query.content" placeholder="请输入讲师介绍"
                                        maxlength="100" show-word-limit />
                                </el-form-item>
                            </el-form>
                            <div class="save" @click="bindSave(queryFormRef)">提交</div>
                        </div>
                    </div>
                </div>
                <!-- 新增讲师 -->
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, getCurrentInstance } from 'vue'
import { getOrgLecturerPageList,addTeacher,delTeacher,updateTeacher } from "../../server/jigou/orgCenter"
import ImageUpload from "../../components/ImageUpload/index.vue"

const addJsStatus = ref(false)
const queryFormRef = ref()
const { proxy } = getCurrentInstance()
const fcTit = ref('新增讲师')
const data = reactive({
    list: [],
    total: 0
})
const query = reactive({
    id:'',
    name:'',
    avatar:'',
    content:''
})
const params = reactive({
    name:'',
    pageSize: 10,
    pageNum: 1,
})
const queryRules = reactive({
    logo: [{ required: true, message: '请上传讲师照片', trigger: "blur" }],
    name: [{ required: true, message: '请输入讲师姓名', trigger: "blur" }],
    content: [{ required: true, message: '请输入讲师介绍', trigger: "blur" }],
})
//获取讲师列表
async function getData(page){
    if( page ){
        params.pageNum = page
    }
    let res = await getOrgLecturerPageList(params)
    if( res != false ){
        data.list = JSON.parse(JSON.stringify(res.list))
        // console.log(data.list);
        data.total = res.total
    }
 }
 getData()
 //上传图片回调
function uploadAvatarSuccess(cbResult){
    console.log(cbResult);
    query.avatar = cbResult   
}
//添加讲师
async function bindSave(formEl){
    await formEl.validate(async (valid, fields) => {
        if (!valid) {
            return;
        }
    })
    let res;
    if( query.id){
        res = await updateTeacher(query)
    }else{
        res = await addTeacher(query)
    }
    
    if( res != false ){
        if( query.id){
            proxy.$modal.msgSuccess("修改讲师成功");
            addJsStatus.value = false
            getData()
        }else{
            proxy.$modal.msgSuccess("添加讲师成功");
            addJsStatus.value = false
            getData()
        }
        
       
    }
}
//删除讲师
function bindDel(delId){
    let delQuery = {
        id: delId
    }
    proxy.$modal.confirm('确认删除该教师吗？').then(async function(){
        let res = await delTeacher(delQuery)
        if( res != false ){
            proxy.$modal.msgSuccess("删除讲师成功");
            getData()
        }
    })
    
}
//修改讲师
function bindEdit(idx,tit){
    query.id = data.list[idx].id
    query.name = data.list[idx].name
    query.avatar = data.list[idx].avatar
    query.content = data.list[idx].content
    fcTit.value = tit
    addJsStatus.value = true
}
function openAddFc(){
    query.id = ''
    query.name = ''
    query.content = ''
    query.avatar = ''
    addJsStatus.value = true
}
//新增讲师
function bindAdd(tit){
    fcTit.value = tit
    addJsStatus.value = true
    openAddFc()
}
//重置
function bindReset(){
    params.name = ''
}
//分页
function bindPage(e){
    console.log(e);
    params.pageNum = e
    getData()
}
 function handleUploadSuccess(e){
    query.avatar = e
}
</script>
<style scoped>
.editor {
    margin-right: 20px;
}

.del {
    border-radius: 3px;
}

.orgCenter .rightBox {
    padding-top: 0px;
    margin-left: 0px;
}
.createSpeaker{
    background: #fff;
}
.createSpeaker .createBox{
    box-shadow:none
}
/* .lecturerBox .topHeader >>> .searchBox{
    background: none;border: 0px;
} */
.lecturerBox .topHeader .searchBox >>>.el-input__inner{
    background: #fff !important;border: 0px;height: unset;line-height: unset;
}
.lecturerBox .lecturerBox .itemlecturer .imgBox{
    width: 150px;height: 150px;
}
.lecturerBox .lecturerBox .itemlecturer .contentBox .contents{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    hyphens: auto;
    height: unset;
}
.lecturerBox .lecturerBox .itemlecturer{
    height: unset;
}
.lecturerBox .lecturerBox .itemlecturer .contentBox{
    height: unset;
}
</style>